import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../contexts/AuthContext";
import toast from "react-hot-toast";
import { Helmet } from 'react-helmet-async';
import axiosInstance from "../utils/axiosInstance";

const MatchRequests = () => {
    const [requests, setRequests] = useState([]);
    const { userId, token } = useContext(AuthContext);

    useEffect(() => {
        const fetchRequests = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_API_BASE}/api/users/${userId}`,
                    {
                        headers: { Authorization: token },
                    }
                );
                const user = res.data;

                const promises = user.requestsReceived.map((id) =>
                    axios.get(`${process.env.REACT_APP_API_BASE}/api/users/${id}`,
                        {
                            headers: { Authorization: token },
                        })
                );
                const requestSenders = await Promise.all(promises);
                setRequests(requestSenders.map((r) => r.data));
            } catch (err) {
                console.error("Failed to load match requests", err);
            }
        };

        fetchRequests();
    }, [userId, token]);

    const acceptRequest = async (fromUserId) => {
        try {
            await axiosInstance.post(
                `${process.env.REACT_APP_API_BASE}/api/match/accept`,
                { userId, fromUserId },
                { headers: { Authorization: token } }
            );
            toast.success("Request accepted!");
            setRequests((prev) => prev.filter((u) => u._id !== fromUserId));
        } catch (err) {
            console.error("Error accepting request", err);
            toast.error("Failed to accept request.");
        }
    };

    const ignoreRequest = async (fromUserId) => {
        try {
            await axiosInstance.post(
                `${process.env.REACT_APP_API_BASE}/api/match/ignore`,
                { userId, fromUserId },
                { headers: { Authorization: token } }
            );
            setRequests((prev) => prev.filter((u) => u._id !== fromUserId));
            toast.success("Request ignored.");
        } catch (err) {
            console.error("Error ignoring request", err);
            toast.error("Failed to ignore request.");
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-white to-indigo-200 px-4">
            <Helmet>
                <title>Match Requests - PairLingo</title>
                <meta name="description" content="Speak with perfect language partner on PairLingo." />
                <meta name="keywords" content="language learning, pairlingo, chat, match, speaking chat, german language partner chat, language speaking practice" />
            </Helmet>
            <div className="max-w-3xl mx-auto pt-12">
                <h2 className="text-2xl font-bold mb-4 text-indigo-700">
                    Incoming Match Requests
                </h2>
                {requests.length === 0 ? (
                    <p className="text-gray-600">No requests yet.</p>
                ) : (
                    <div className="space-y-4">
                        {requests.map((user) => (
                            <div key={user._id} className="bg-white p-4 shadow rounded">
                                <h3 className="text-lg font-semibold">{user.username}</h3>
                                <p>
                                    {user.targetLanguage} - Level {user.level}
                                </p>
                                <p className="text-sm text-gray-600 italic mt-1">"{user.bio}"</p>
                                <div className="mt-3 flex gap-3">
                                    <button
                                        className="bg-green-600 text-white px-4 py-1 rounded hover:bg-green-500"
                                        onClick={() => acceptRequest(user._id)}
                                    >
                                        Accept Request
                                    </button>

                                    <button
                                        className="bg-gray-400 text-white px-4 py-1 rounded hover:bg-gray-500"
                                        onClick={() => ignoreRequest(user._id)}
                                    >
                                        Ignore
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MatchRequests;
